import { Avatar, Badge, Box, Button, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';
import { FiEdit, FiUser } from 'react-icons/fi';
import { HiPlus } from 'react-icons/hi2';
import { TbShieldCheckFilled } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../helper/utils/navigation';

export default function UserProfileCard({ user, onEdit, onShowQR }) {
    const [showQR, setShowQR] = useState(false);
    const navigate = useNavigate();

    const handleQRClick = () => {
        setShowQR(!showQR);
        if (onShowQR) {
            onShowQR();
        }
    };

    return (
        <Box bg='white' borderRadius='2xl' p={{ base: 4, md: 6 }} border='1px' borderColor='gray.100'>
            <Flex gap={4} w='full' flexDirection={{ base: 'column', md: 'row' }}>
                {/* Avatar and User Info */}
                <Flex direction={{ base: 'column', sm: 'row' }} align='center' gap={{ base: 4, md: 6 }} w='full'>
                    {/* Avatar */}
                    <Avatar size={{ base: 'lg', md: 'xl' }} name={user?.fullname || 'User'} src={user?.avatar} bg='primary.500' color='white' icon={<FiUser size={40} />} />

                    {/* User Info */}
                    <VStack align={{ base: 'center', sm: 'start' }} flex={1} spacing={1} w={{ base: 'full', sm: 'auto' }}>
                        <Text fontSize={{ base: 'xl', md: '2xl' }} fontWeight='bold' color='gray.800' textAlign={{ base: 'center', sm: 'left' }}>
                            {user?.fullname || 'Guest User'}
                        </Text>
                        <Text fontSize={{ base: 'sm', md: 'md' }} color='gray.600' textAlign={{ base: 'center', sm: 'left' }}>
                            {user?.phone || 'No phone number'}
                        </Text>
                        <Badge colorScheme='purple' fontSize='sm' px={3} py={1} borderRadius='full' mt={2}>
                            <Flex align='center' gap={1}>
                                <Icon as={TbShieldCheckFilled} />
                                Waiver
                            </Flex>
                        </Badge>
                    </VStack>
                </Flex>

                {/* Action Buttons */}
                <Flex direction={{ base: 'column', sm: 'row' }} gap={3} w={{ base: 'full', sm: 'auto' }}>
                    <Button
                        isDisabled={false}
                        colorScheme='green'
                        size={{ base: 'md', md: 'sm' }}
                        fontSize={{ base: 'xs', md: 'sm' }}
                        leftIcon={<FiEdit />}
                        onClick={onEdit}
                        borderRadius='full'
                        w={{ base: 'full', sm: 'auto' }}
                        _hover={{
                            transform: 'translateY(-2px)',
                        }}
                        transition='all 0.2s'>
                        Update Profile
                    </Button>
                    <Button
                        isDisabled={false}
                        colorScheme='blue'
                        size={{ base: 'md', md: 'sm' }}
                        fontSize={{ base: 'xs', md: 'sm' }}
                        leftIcon={<HiPlus />}
                        borderRadius='full'
                        w={{ base: 'full', sm: 'auto' }}
                        _hover={{
                            transform: 'translateY(-2px)',
                        }}
                        transition='all 0.2s'
                        onClick={() => navigate(urlNavigate('dashboard/account-details/edit-child'))}>
                        Add Your Child
                    </Button>
                    {/* <Button
                        isDisabled
                        leftIcon={<PiQrCode fontSize='20px' />}
                        colorScheme='purple'
                        size={{ base: 'md', md: 'sm' }}
                        fontSize={{ base: 'xs', md: 'sm' }}
                        onClick={handleQRClick}
                        borderRadius='full'
                        w={{ base: 'full', sm: 'auto' }}
                        _hover={{
                            transform: 'translateY(-2px)',
                        }}
                        transition='all 0.2s'>
                        QR Code
                    </Button> */}
                </Flex>
            </Flex>

            {/* QR Code Display */}
            {showQR && (
                <Flex justify='center' mt={6} p={4} bg='gray.50' borderRadius='xl'>
                    <Box bg='white' p={4} borderRadius='lg' shadow='sm'>
                        <QRCodeSVG value={user?.id || 'user-id'} size={window.innerWidth < 480 ? 150 : 200} level='H' includeMargin />
                    </Box>
                </Flex>
            )}
        </Box>
    );
}
